import { render, staticRenderFns } from "./InputAutosuggest.vue?vue&type=template&id=53bb4748&"
import script from "./InputAutosuggest.vue?vue&type=script&lang=js&"
export * from "./InputAutosuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports